/**
 * 金額をカンマ区切りに表示します。
 * @param value 金額
 */
export function addComma(value) {
  return `${Number(value).toLocaleString()}`
}

/**
 * 日付をスラッシュ区切りにします
 * @param value YYYYMM
 */
export function addSlashToCalendarYM(value) {
  let val = String(value)
  return `${val.substr(0, 4)}/${val.substring(4, val.length)}`
}

/**
 * 日付をスラッシュ区切りにします
 * @param value YYYYMMDD
 */
export function addSlashToCalendarYMD(value) {
  let val = String(value)
  return `${val.substr(0, 4)}/${val.substring(4, 6)}/${val.substring(6, val.length)}`
}

/**
 * 時間をHH:MM:SSをMM:SSのフォーマットへ変換します。
 * @param value HH:MM:SS
 */
export function formatToMMSS(value) {
  let val = String(value)
  return `${val.slice(-5)}`
}

/**
 * 性別を日本語で返却します。
 * @param value String(length:1)
 */
export function setGenderJapanese(value) {
  let val = String(value)
  let genderStr = ''

  switch (val) {
    case 'F':
      genderStr = '女性'
      break

    case 'M':
      genderStr = '男性'
      break
  }
  return `${genderStr}`
}

/**
 * イニシャルを大文字にします
 * @param value String
 * @return String
 **/
export function setUpperCase(value) {
  let val = String(value)
  return val.charAt(0).toUpperCase() + val.slice(1)
}

/**
 * 時刻をコロン区切りにします
 * @param value
 * @return String
 **/
export function addColonToHHMM(value) {
  console.log(value)
  let val = String(value)
  console.log(val)
  return `${val.substr(0, 2)}:${val.substring(2, 4)}`
}

/**
 * カード番号表示用 ************1234 → **** **** **** 1234にします
 * @param value カード番号
 */
export function cardNumberFormat(value) {
  return `**** **** **** ${value.substr(12, 16)}`
}

/**
 * クレカ有効期限表示用 202403 → 03/2024 にします
 * @param value クレカ有効期限
 */
export function cardExpirationFormat(value) {
  return `${value.substr(4, 6)}/${value.substr(0, 4)}`
}

/**
 * 日付を 2020-01-01 → 2020年1月1日 にします
 * @param value 日付
 */
export function convertKanjiYMD(value) {
  return moment(value).format('YYYY年M月D日')
}

/**
 * 日付を 2020-01-01 → 2020/1/1 にします
 * @param value 日付
 */
export function convertSlashYMD(value) {
  return moment(value).format('YYYY/M/D')
}

/**
 * 秒　→ mm:ssに変換
 * @param {*} seconds
 */
export function secondsToMinutesAndSeconds(seconds) {
  const min = Math.floor(seconds / 60)
  const sec = Math.round(seconds % 60)
  return `${('00' + min).slice(-2)}:${('00' + sec).slice(-2)}`
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/filters.js